import { WorkerAction, WorkerActionError, WorkerFnParams } from '../wasm-git.worker.model';
import { FSAction, GitAction } from './actions.enum';
import { FSRemoveEmptyDirsFn } from './fs-remove-empty-dirs';

export interface GitResetAction extends WorkerAction {
  type: GitAction.Reset;
  params?: string[];
}

export class GitResetActionError extends WorkerActionError {}

export async function GitResetActionFn(params: WorkerFnParams<GitResetAction>): Promise<void | string> {
  const { util, lg, params: gitParams } = params;

  try {
    if (gitParams) {
      return lg.callAndCaptureOutput(['reset', ...(gitParams || [])]);
    }

    await FSRemoveEmptyDirsFn({ ...params, params: { type: FSAction.RemoveEmptyDirs } });
    await util.syncfs(false);
  } catch (err) {
    throw new GitResetActionError(err);
  }
}
